import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import SocialMedia from "../SocialMedia/SocialMedia";
import TextCarousel from "../TextCarousel/TextCarousel";
import { navigationLinks } from "../../data/navigation";
import { CONTACT_FORM_EMAIL } from "../../utils/contactFormSubmission";
import logo from "../../Assets/logo-white.webp";
import "./Footer.scss";

const footerGroups = [
  { id: "explore", title: "Explore" },
  { id: "capabilities", title: "Capabilities" },
];

function Footer() {
  return (
    <div className="footer-wrap">
      <TextCarousel />
      <footer className="footer mobile-type">
        <Container className="footer-container">
          <div className="footer-content">
            <div className="footer-brand-column">
              <Link to="/" className="footer-logo" aria-label="Klean Leaf home">
                <img src={logo} alt="" width="56" height="56" />
                <span className="footer-brand">Klean Leaf</span>
              </Link>
              <p className="footer-description">
                Private-label laundry &amp; home care products.
              </p>
              <Link to="/products" className="footer-product-link">
                Explore Products <FiArrowUpRight aria-hidden="true" focusable="false" />
              </Link>
            </div>

            <nav className="footer-navigation" aria-label="Footer navigation">
              {footerGroups.map(({ id, title }) => (
                <div className="footer-link-group" key={id}>
                  <h2 className="footer-heading">{title}</h2>
                  <ul>
                    {navigationLinks.filter((link) => link.footerGroup === id).map(({ to, label, footerLabel }) => (
                      <li key={to}>
                        <Link to={to}>{footerLabel || label}</Link>
                      </li>
                    ))}
                    {id === "capabilities" && (
                      <li><Link to="/products?category=kit">Product kits</Link></li>
                    )}
                  </ul>
                </div>
              ))}
            </nav>

            <div className="footer-contact">
              <h2 className="footer-heading">Get in touch</h2>
              <address>
                <a href={"mailto:" + CONTACT_FORM_EMAIL}>{CONTACT_FORM_EMAIL}</a>
                <a href="tel:+16149065129">614.906.5129</a>
                <Link to="/contact">Contact us&nbsp;<span aria-hidden="true">→</span></Link>
              </address>
              <div className="footer-socials">
                <SocialMedia />
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <small>© {new Date().getFullYear()} Klean Leaf. All rights reserved.</small>
          </div>
        </Container>
      </footer>
    </div>
  );
}

export default Footer;
